'use strict';

function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });

    updateDom($results, '.refinements');
}

/**
 * @description parseResultsMobile function update the filter list in the front-end
 * @param {number} response - Data backend
 */
function parseResultsMobile(response) {
    const $results = $(response);
    const specialHandlers = {
        '.refinements': handleRefinements
    };
    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header.page-title',
        '.filter-bar',
        '.show-more'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };
    
    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}


function getContent($element, $target) {
    var showMoreUrl = $element.data('url');
    $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: 'GET',
        success: function (response) {
            $target.append(response);
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    
    if ($tempDom.find('.grid-footer').length > 0) {
        var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
        
        sortOptions.forEach(function (option) {
            $('option.' + option.id).val(option.url);
        });
    }
}


module.exports = {
    parseResults:parseResults,
    getContent:getContent,
    updateSortOptions:updateSortOptions,
    parseResultsMobile : parseResultsMobile
}